import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ILicenceProfile } from "../../api/ILicenceProfile";

interface IBreadCrumbProps {
  licenceProfile: ILicenceProfile;
}

const BreadCrumbs = ({ licenceProfile }: IBreadCrumbProps) => {
  const text = `${licenceProfile.organisation} - ${licenceProfile.profileNo}`;
  return (
    <Row>
      <Col xs="12">
        <Breadcrumb className="leap">
          <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
          <Breadcrumb.Item active>{text}</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
    </Row>
  );
};

export default BreadCrumbs;
